import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.BUSINESS_OPERATIONS}.${BUSINESS_TOOL_SUB_SECTIONS.BUSINESS_OPERATIONS.WORKING_RESOURCES}` as const;

export const WORKING_RESOURCES_NAMES = {
  NECESSARY_RECOURSES: 'necessaryRecourses',
  AVAILABILITY: 'availability',
} as const;

export interface IWorkingRecourses {
  [WORKING_RESOURCES_NAMES.NECESSARY_RECOURSES]: string;
  [WORKING_RESOURCES_NAMES.AVAILABILITY]: string;
}

export const workingRecoursesInitialValues = {
  [WORKING_RESOURCES_NAMES.NECESSARY_RECOURSES]: '',
  [WORKING_RESOURCES_NAMES.AVAILABILITY]: '',
};
